import React from "react";
import { StyledServerRequestLoadingScreen } from "./styled";
import { useIconsByAccount } from "../../utils/useIconsByAccount";

export const ServerRequestLoadingScreen = () => {
  const { awaiting } = useIconsByAccount();
  return (
    <StyledServerRequestLoadingScreen>
      <img className={"image"} src={awaiting} alt="error" />
    </StyledServerRequestLoadingScreen>
  );
};
